import React from 'react';
import {NavLink as Link} from 'react-router-dom';
import PublishStatusDot from '../../../misc/PublishStatusDot.js';
import AssetField from '../../../contentful/AssetField';
import BlockEditor from '../../../block-editor/Editor';
import update from 'immutability-helper';

class ModelPageComponent extends React.Component {
  constructor(props) {
    super(props);

    this.handlePublish = this.handlePublish.bind(this);
    this.handleUnpublish = this.handleUnpublish.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleAssetChange = this.handleAssetChange.bind(this);

    this.urlUntouched = true;

    this.state = {
      pageUrl: ''
    };
  }

  componentDidMount() {
    if (this.props.page && this.props.page.url) {
      this.urlUntouched = false;
      this.updateUrlState(this.props.page.url.toLowerCase());
    }
  }

  updateUrlState(url) {
    this.setState({
      pageUrl: url
    });
  }

  /* Handle submit */
  handleSubmit(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handlePublish(e) {
    e.preventDefault();
    this.props.onPublish();
  }

  handleUnpublish(e) {
    e.preventDefault();
    this.props.onUnpublish();
  }

  handleSave(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handleFieldChange(e) {
    const newData = {
      page: {}
    };

    let value = e.target.value;

    if (e.target.name === 'title' && (!this.props.page.url || this.urlUntouched)) {
      // Update URL field on title change if empty
      const url = value.replace(/[^\w.,-]/g, '-').toLowerCase();
      newData.page.url = {
        $set: url
      };

      this.updateUrlState(url);
    } else if (e.target.name === 'url') {
      this.urlUntouched = false;
      value = value.replace(/[^\w.,-]/g, '-').toLowerCase();
      this.updateUrlState(value);
    }

    newData.page[e.target.name] = {
      $set: value
    };

    const props = update(this.props, newData);

    this.props.onChange(props);
  }

  handleAssetChange(name, asset) {
    const change = {
      page: {}
    };

    change.page[name] = {
      $set: asset
    };

    const props = update(this.props, change);

    this.props.onChange(props);
  }

  render() {
    const page = this.props.page;

    const predefinedTags = [this.props.model.make.name, (this.props.model.displayname || this.props.model.name)];

    return (
      <section className="mf-model">
        <ol className="breadcrumb mf-margin-top-20">
          <li><Link to="/">Forsiden</Link></li>
          <li><Link to="/nybilinformasjon/">Nybilinformasjon</Link></li>
          <li>
            <Link to={`/modeller/${this.props.model.make.id}`}>{this.props.model.make.name}</Link>
          </li>
          <li>
            <Link to={`/modeller/${this.props.model.make.id}/modell/${this.props.model.id}`}>{this.props.model.name}</Link>
          </li>
          <li className="active">{page.title}</li>
        </ol>

        <form onSubmit={this.handleSubmit}>
          <div className="page-header">
            <div className="row">
              <div className="col-xs-12 col-sm-8">
                <h1>{page.title} <PublishStatusDot entry={page} /><br/>
                  <small>Underside</small></h1>
              </div>

              <div className="col-xs-12 col-sm-4 text-right mf-padding-top-10">
                {this.props.working &&
                  <span><i className="fa fa-spinner fa-pulse fa-fw"></i> Arbeider...&nbsp;</span>
                }
                {!page.archived &&
                  <button
                    type="submit"
                    className="btn btn-default"
                    disabled={!this.props.modified || this.props.working}
                  >
                    <span>Lagre endringer</span>
                  </button>
                }
                &nbsp;
                <button
                  type="button"
                  className="btn btn-success"
                  disabled={page.archived || (page.published && !page.updated) || this.props.working || this.props.modified}
                  onClick={this.handlePublish}
                >
                  <span>Publiser</span>
                </button>
                &nbsp;
                <button
                  type="button"
                  className="btn btn-warning"
                  disabled={page.draft || this.props.working || this.props.modified}
                  onClick={this.handleUnpublish}
                >
                  <span>Avpubliser</span>
                </button>
                &nbsp;
                {!page.archived &&
                  <button
                    type="button"
                    className="btn btn-danger"
                    disabled={(this.props.working)}
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.onArchive();
                    }}
                  >
                    <span>Arkiver</span>
                  </button>
                }
                {page.archived &&
                  <button
                    type="button"
                    className="btn btn-danger"
                    disabled={(this.props.working)}
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.onUnArchive();
                    }}
                  >
                    <span>Gjenopprett</span>
                  </button>
                }
              </div>
            </div>
          </div>

          {/* Display any error message: */}
          {this.props.error &&
            <div className="alert alert-danger">
              {this.props.error}
            </div>
          }

          <div className="row">
            <div className="col-xs-12 col-md-6">
              <div className="form-group">
                <label>Tittel</label>
                <input type="text" className="form-control" name="title" disabled={page.archived || this.props.working} defaultValue={page.title} onChange={this.handleFieldChange} required />
              </div>

              <div className="form-group">
                <label>URL</label>
                <input type="text" className="form-control" name="url" pattern="^([\w,.-])+?$" disabled={page.archived || this.props.working} defaultValue={page.url} onChange={this.handleFieldChange} required />
              </div>
            </div>
            <div className="col-xs-12 col-md-6">
              <div className="form-group">
                <label>Bilde</label>
                <AssetField name="image" allowVideo={this.props.model.make.name === 'Hongqi'} value={page.image} onChange={this.handleAssetChange} disabled={this.props.working} predefinedTags={predefinedTags} />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12">
              <div className="form-group">
                <label>Innhold</label>
                <div>
                  <BlockEditor
                    blocks={page.bodytext}
                    onChange={(blocks) => this.handleAssetChange('bodytext', blocks)}
                    disabled={!page.id || this.props.working}
                    enableTwoColumns
                    enableModelContent
                    enableBlockAdjustments
                    allowVideo
                    predefinedTags={predefinedTags}
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
      </section>
    );
  }
}

ModelPageComponent.defaultProps = {
  page: null,
  modified: null,
  working: null,
  onChange: () => {},
  onSave: () => {},
  onPublish: () => {}
};

export default ModelPageComponent;
